import paging from '@/components/paging/paging.vue';

export const pagingNation = {
  install: (Vue) => {
    Vue.component('paging', paging)
  }
}



// WEBPACK FOOTER //
// ./src/components/paging/index.js